import React from 'react';
import { Button } from 'react-bootstrap';
import DetailMoreInformation from '../../components/DetailMoreInformation';
import ViewDetails from '../../components/ViewDetails';

const DetailsSection = ({
    openDetailsSection,
    userPermission,
    isLocked,
    moreInformation,
    openEditDetails,
    openMore,
}) => {
    return openDetailsSection ? (
        <div className='wrap_details p-4'>
            <div className='d-flex details_part mb-3 align-items-stretch justify-content-between'>
                <div className='details_fun'>
                    <span>
                        <i
                            title='Details'
                            className='fa-solid fa-notes-medical'
                        ></i>
                        Details
                    </span>
                </div>
                {(userPermission.allActions.hasOwnProperty(
                    'save_partial_attach_to_chart'
                ) &&
                    userPermission.allActions.save_partial_attach_to_chart
                        .actionId !== '') ||
                (userPermission.allActions.hasOwnProperty('attach_to_chart') &&
                    userPermission.allActions.attach_to_chart.actionId !==
                        '') ||
                (userPermission.allActions.hasOwnProperty(
                    're_attach_to_chart'
                ) &&
                    userPermission.allActions.re_attach_to_chart.actionId) ? (
                    <div className='edit_details'>
                        <Button
                            variant='primary'
                            title='Edit Details'
                            disabled={isLocked}
                            onClick={openEditDetails}
                        >
                            Edit Details
                        </Button>
                    </div>
                ) : null}
            </div>
            <ViewDetails />
            <div className='more_info' onClick={openMore}>
                <a href='#ngo' className='mt-4 mb-4'>
                    {moreInformation ? (
                        <div>
                            <i className='fa-regular fa-chevron-up' />
                            <button type='button'> Less Information</button>
                        </div>
                    ) : (
                        <div>
                            <i className='fa-regular fa-chevron-down' />
                            <button type='button'> More Information</button>
                        </div>
                    )}
                </a>
            </div>
            {moreInformation ? <DetailMoreInformation /> : null}
        </div>
    ) : null;
};

export default DetailsSection;
